import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getBusinessGroupQuantityDatatable,
  createNewBusinessQuantity,
} from './thunks';
import { businessGroupQuantityState } from './types';

export const name = 'BusinessGroupQuantity';

const initialState: businessGroupQuantityState = {
  data: null,
  status: 'idle',
};
export const getBusinessQuantityDatatableAsync = createAsyncThunk(
  name + '/getBusinessGroupQuantityDatatable',
  getBusinessGroupQuantityDatatable
);
export const createnewBusinessQuantityAsync = createAsyncThunk(
  name + '/createNewBusinessQuantity',
  createNewBusinessQuantity
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessQuantityDatatableAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBusinessQuantityDatatableAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getBusinessQuantityDatatableAsync.rejected, (state, action) => {
        state.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
